<div>
  <h2>Changer le mot de passe</h2>
  <form (ngSubmit)="changePassword()">
    <div>
      <label for="oldPassword">Ancien mot de passe</label>
      <input id="oldPassword" type="password" [(ngModel)]="oldPassword" name="oldPassword" required>
    </div>
    <div>
      <label for="newPassword">Nouveau mot de passe</label>
      <input id="newPassword" type="password" [(ngModel)]="newPassword" name="newPassword" required>
    </div>
    <button type="submit">Changer le mot de passe</button>
  </form>
  <p *ngIf="message">{{ message }}</p>
</div>
